var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.129,
    height: 62.129,
    viewBox: "0 0 62.129 62.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22",
    "data-name": "Layer 22",
    transform: "translate(-2.001 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M55.03,11.1a31.064,31.064,0,1,0,0,43.934,31.064,31.064,0,0,0,0-43.934ZM44.158,40.919a2.252,2.252,0,1,1-3.129,3.24l-7.966-7.966-7.855,7.966A2.212,2.212,0,1,1,22.08,41.03l7.855-7.966L22.08,25.21a2.219,2.219,0,0,1,3.129-3.129l7.855,7.855,7.855-7.855a2.252,2.252,0,0,1,3.24,3.129l-7.966,7.855Z",
    transform: "translate(0 0)",
    fill: "rgba(2,7,35,0.3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modal-close-icon.c3ec8709169dbd768706f6a9c23f6828.svg";
export { ForwardRef as ReactComponent };